define('TescoMobile_CheckoutCareHub/js/view/about/checkout-agreements-mixin',['jquery'], function ($) {
  'use strict';

  var mixin = {
    getCheckboxId: function (agreementId) {
      var id = '#agreement_' + agreementId;
      $(document).trigger('tm:carehub:disableCheckbox', id);
      return 'agreement_' + agreementId;
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

